import React from 'react';
import Input from '../../../components/ui/Input';
import ImageUploadField from '../../../components/media/ImageUploadField';
import Icon from '../../../components/AppIcon';

const CmsMetaSection = ({ content, onChange, weddingId }) => {
  const meta = content?.meta || {};

  const updateMeta = (field, value) => {
    onChange({
      ...content,
      meta: { ...meta, [field]: value },
    });
  };

  return (
    <div className="bg-card rounded-xl p-4 md:p-6 shadow-romantic-sm border border-border">
      <div className="flex items-center gap-3 mb-4">
        <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center">
          <Icon name="Globe" size={20} color="var(--color-primary)" />
        </div>
        <h3 className="text-lg font-semibold text-foreground">SEO & Meta Tags</h3>
      </div>

      <div className="space-y-4">
        <Input
          label="Page Title"
          type="text"
          placeholder="e.g., Sarah & Michael's Wedding"
          value={meta.pageTitle || ''}
          onChange={(e) => updateMeta('pageTitle', e.target.value)}
        />
        <Input
          label="Description"
          type="text"
          placeholder="Page description for search engines"
          value={meta.description || ''}
          onChange={(e) => updateMeta('description', e.target.value)}
        />
        <Input
          label="OG Title"
          type="text"
          placeholder="Social sharing title"
          value={meta.ogTitle || ''}
          onChange={(e) => updateMeta('ogTitle', e.target.value)}
        />
        <Input
          label="OG Description"
          type="text"
          placeholder="Social sharing description"
          value={meta.ogDescription || ''}
          onChange={(e) => updateMeta('ogDescription', e.target.value)}
        />
        <ImageUploadField
          label="OG Image URL"
          placeholder="https://... or upload"
          value={meta.ogImage || ''}
          onChange={(e) => updateMeta('ogImage', e.target.value)}
          showPreview={true}
          weddingId={weddingId}
        />
      </div>
    </div>
  );
};

export default CmsMetaSection;
